/**
 * return dataLayer's eventData for every order item tracking tag
 * @param {jQuery} $orderItem - top div of order item
 * @return {Object} order Item eventData
 */
export function getOrderItemData($orderItem) {
  const basicOrderData = {
    placement: 'My Order page',
    label: $.trim($orderItem.find('.js-order-item-label').text()),
    labelIdentifier: 'Item_Info',
    orderId: $orderItem.closest('.js-order').data('order-id'),
    itemId: $orderItem.data('sku'),
    orderType: $orderItem.data('order-type')
  };

  const $orderItemInfo = $orderItem.find('.js-order-item-info');
  const $spareParts = $orderItem.find('.js-spare-part-status');

  const itemStatus = $orderItemInfo.data('item-status');
  const deliveryType = $orderItemInfo.data('delivery-type');

  const exchangeStatus = $orderItem
    .find('.js-exchange-status')
    .data('item-status');

  const hasExchange = exchangeStatus !== undefined;
  const hasReturn = deliveryType === 'return';
  const hasSpareParts = $spareParts.length > 0;

  if (hasSpareParts) {
    return {
      ...basicOrderData,
      itemStatus: $spareParts.toArray().map(el => el.dataset['itemStatus']),
      lastOrderType: $orderItem.data('last-order-type')
    };
  }

  if (hasExchange) {
    return {
      ...basicOrderData,
      itemStatus: hasReturn
        ? {
            return: itemStatus,
            exchange: exchangeStatus
          }
        : exchangeStatus
    };
  }

  return {
    ...basicOrderData,
    itemStatus
  };
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/myAccount/helper.js
 **/